import { Component, OnInit } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;

@Component({
  selector: "app-pricing",
  templateUrl: "./pricing.component.html",
  styleUrls: ["./pricing.component.scss"]
})
export class PricingComponent implements OnInit {
  lang: string;

  constructor(private base: BaseService) {}

  ngOnInit() {
    this.lang = this.base.getLang();

    $("#orangeModalSubscription").on("show.bs.modal", function(event) {
      var button = $(event.relatedTarget); // Button that triggered the modal
      var recipient = button.data("whatever"); // Extract info from data-* attributes
      $("#price input[name*='subject']").val("Pacakge " + recipient);
      $("#price input[name*='message']").val(
        recipient +
          "TakeID:" +
          new Date().getTime() +
          "\n" +
          " Request At : " +
          new Date()
      );
    });

    // -------   Mail Send ajax

    $(document).ready(function() {
      var form = $("#price"); // contact form
      var button = $("#price button");
      var submit = $(".submit-p-btn"); // submit button
      var onsubmit = $(".loading-p-btn"); // submit button
      var alert = $(".alert-msg"); // alert div for show alert message

      onsubmit.fadeOut("fast");

      // form submit event
      form.on("submit", function(e) {
        e.preventDefault(); // prevent default form submit
        button.attr("disabled", true);

        $.ajax({
          url: "mail.php", // form action url
          type: "POST", // form submit method get/post
          dataType: "html", // request type html/json/xml
          data: form.serialize(), // serialize form data
          beforeSend: function() {
            // alert.fadeOut();
            if (submit.css("display") != "none") {
              submit.css("display", "none");
              onsubmit.fadeIn();
            }
          },
          success: function(data) {
            // alert.html(data).fadeIn();
            // fade in response data
            $("#orangeModalSubscription").modal("hide");
          },
          error: function(e) {
            $("#price .alert.alert-danger").fadeIn();
          },
          complete: function() {
            if (onsubmit.css("display") != "none") {
              onsubmit.css("display", "none");
              submit.fadeIn(function() {
                button.attr("disabled", false);
              });
            }
          }
        });
      });
    });
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
    var button = $("#price button");
    var submit = $(".submit-p-btn"); // submit button
    var onsubmit = $(".loading-p-btn"); // submit button

    if (onsubmit.css("display") != "none") {
      onsubmit.css("display", "none");
      submit.fadeIn(function() {
        button.attr("disabled", false);
      });
    }
  }
}
